module.exports = "/_next/static/images/mechanicalConstruction-80aa7227ca65e5c4142ce5ea8179283a.webp";